import { connect } from 'react-redux'
import ContentParagraph from 'components/legislation-reference/ContentParagraph'

const mapStateToProps = state => ({
  highlighted: state.legislationReference.highlighted
})

export default connect(mapStateToProps, null)(ContentParagraph)
